module.exports = __webpack_public_path__ + "static/media/about-us.f36c14e1.jpg";